module.exports = __webpack_public_path__ + "static/img/title.e3389ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/media5/title.png
// module id = i2Sj
// module chunks = 7